var _rect, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgErrorProcessing = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 120,
    height: 120,
    rx: 60,
    fill: "#7B66F2",
    fillOpacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60,
    r: 44,
    fill: "#7B66F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.07 71.1907L63.279 45.603C62.707 44.6141 61.6423 44 60.4995 44C59.3567 44 58.292 44.6141 57.72 45.603L42.929 71.1907C42.357 72.1796 42.357 73.4081 42.929 74.397C43.4998 75.3859 44.5646 76 45.7085 76H75.2905C76.4345 76 77.4992 75.3859 78.07 74.397C78.6431 73.4078 78.6431 72.1796 78.0711 71.1907H78.07ZM76.6438 73.5746C76.3655 74.056 75.8467 74.355 75.2897 74.355L45.7077 74.3554C45.1507 74.3554 44.6319 74.056 44.3536 73.5749C44.0749 73.0931 44.0749 72.4951 44.3536 72.0133L59.1446 46.4255C59.4233 45.9441 59.9421 45.6451 60.4987 45.6451C61.0553 45.6451 61.5738 45.9445 61.8528 46.4255L76.6438 72.0133C76.9226 72.4947 76.9226 73.0927 76.6434 73.5745L76.6438 73.5746ZM60.4993 54.6317C60.0448 54.6317 59.6762 54.9999 59.6762 55.4538V64.4987C59.6762 64.9526 60.0448 65.3209 60.4993 65.3209C60.9537 65.3209 61.3224 64.9526 61.3224 64.4987V55.4538C61.3224 55.0003 60.9537 54.6317 60.4993 54.6317ZM60.4993 67.4691C60.0448 67.4691 59.6762 67.8373 59.6762 68.2912V70.0272C59.6762 70.4811 60.0448 70.8493 60.4993 70.8493C60.9537 70.8493 61.3224 70.4811 61.3224 70.0272V68.2912C61.3224 67.8373 60.9537 67.4691 60.4993 67.4691Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgErrorProcessing);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/error-processing.0e986707d066e48056f4895bff1abc09.svg";